// extracted by mini-css-extract-plugin
export var navLinkList = "navMenu-module--navLinkList--_F4S8";
export var navLink = "navMenu-module--navLink--1n3Ht";
export var navWrapper = "navMenu-module--navWrapper--1vH48";
export var navLinkListItem = "navMenu-module--navLinkListItem--3V02F";